import {
    ENTER,
    ESCAPE,
} from '@angular/cdk/keycodes';
import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import {
    filter,
    takeUntil,
} from 'rxjs/operators';

@Component({
    selector: 'ui-dialog',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: 'ui-dialog.template.html',
})
export class UiDialogComponent {
    @Input()
    public isAlertDialog = false;

    @Input()
    public modalText?: string;

    @Input()
    public focusNoButton = false;

    constructor(public dialogRef: MatDialogRef<UiDialogComponent>) {
        dialogRef.keydownEvents()
            .pipe(
                filter(event => [ENTER, ESCAPE].includes(event.keyCode)),
                takeUntil(dialogRef.beforeClosed()),
            )
            .subscribe(event => event.stopPropagation());
    }

    public safeGuardOk(msg: string) {
        if (
            msg.includes('global_dialog_ok') ||
            msg.includes('global_dialog_yes')
        ) {
            return 'Ok';
        }

        return msg;
    }
}
